// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2SZrr","tab":"Tabs_tab__14Wts","tabActive":"Tabs_tabActive__1hWDy"};